/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitTag,
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';

/**
 * 
 * @export
 * @interface GetPressKitTagListResponse
 */
export interface GetPressKitTagListResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitTagListResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitTagListResponse
     */
    message: string;
    /**
     * 企業が設定しているタグの一覧
     * @type {Array<PressKitTag>}
     * @memberof GetPressKitTagListResponse
     */
    readonly data: Array<PressKitTag>;
}

export function GetPressKitTagListResponseFromJSON(json: any): GetPressKitTagListResponse {
    return GetPressKitTagListResponseFromJSONTyped(json, false);
}

export function GetPressKitTagListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitTagListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function GetPressKitTagListResponseToJSON(value?: GetPressKitTagListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

